module.exports = __webpack_public_path__ + "img/single-occupancy.78c6813e.webp";